import { UseQueryOptions } from 'react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';
import { CohortWithPatients } from 'domains/segments/types';

const useSegmentCohort = (cohortId: string, reactQueryOptions?: UseQueryOptions<CohortWithPatients, Error>) =>
    useQuery<CohortWithPatients>(
        QueryKeys.SEGMENT_COHORT_ID(cohortId),
        `${CuredApiPaths.SEGMENTS}/cohorts/${cohortId}`,
        reactQueryOptions
    );

export default useSegmentCohort;
